export default {"src":"/_next/static/media/integration.a1ff4d45.svg","height":438,"width":559,"blurWidth":0,"blurHeight":0};